<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>授权码管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.upload_key" placeholder="输入部分或全部授权码"></el-input>
      </el-form-item>
      <el-form-item label="状态">
        <el-select size="small" v-model="formInline.status" placeholder="请选择">
          <el-option v-for="type in status_type" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-upload" @click="handleGenKeys()">补充秘钥</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
              element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="selection" width="60">
      </el-table-column>
      <el-table-column align="center" sortable prop="id" label="id" width="60">
      </el-table-column>
      <el-table-column align="center" sortable prop="upload_key" label="上传密钥" min-width="135">
      </el-table-column>
      <el-table-column align="center" sortable prop="feature_key" label="FeatureKey" min-width="160">
      </el-table-column>
      <el-table-column align="center" sortable prop="apple_account" label="开发者账号" min-width="160">
      </el-table-column>
      <el-table-column align="center" sortable prop="apple_password" label="专用密码" width="160">
      </el-table-column>
      <el-table-column align="center" sortable prop="bundle_id" label="Bundle ID" width="120">
      </el-table-column>
      <el-table-column align="center" sortable prop="bundle_version" label="Bundle Version" width="100">
      </el-table-column>
      <el-table-column align="center" sortable prop="bundle_short_version" label="Short Version" width="100">
      </el-table-column>
      <!-- 状态列：根据数值显示彩色标签 -->
      <el-table-column align="center" sortable prop="status" label="状态" width="80">
        <template slot-scope="scope">
          <el-tag :type="statusTagType(scope.row.status)" size="small">
            {{ statusText(scope.row.status) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" sortable prop="create_time" label="生成时间" width="140">
        <!-- 如有需要可添加时间格式化 -->
      </el-table-column>
      <el-table-column align="center" sortable prop="update_time" label="更新时间" width="140">
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="100">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteItem(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click="closeDialog">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="状态" prop="status">
          <el-select size="small" v-model="editForm.status" placeholder="请选择" class="userRole">
            <el-option v-for="type in status_type" :label="type.key" :value="type.value" :key="type.value"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存
        </el-button>
      </div>
    </el-dialog>

    <!-- 补充秘钥界面 -->
    <el-dialog :title="title" :visible.sync="genKeyFormVisible" width="30%" @click="closeDialog">
      <el-form label-width="120px" :model="genKeyForm" :rules="rules" ref="editForm">
        <el-form-item label="数量">
          <el-input size="small" v-model="genKeyForm.count" placeholder="输入生成个数"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitGen()">生成
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {deleteUploadKey, getUploadKeyList, updateKeyStatus, genNewUploadKeys} from '../../api/keyMG'
import Pagination from '../../components/Pagination'

export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      genKeyFormVisible: false, //控制生成页面显示与隐藏
      title: '编辑',
      editForm: {
        id: '',
        status: -1,
      },
      genKeyForm: {
        count: 0
      },
      status_type: [
        {key: '请选择', value: -1},
        {key: '待售', value: 0},
        {key: '已售', value: 1},
        {key: '使用中', value: 2},
        {key: '已消耗', value: 3},
        {key: '已封禁', value: 4},
      ],
      // 预先生成状态映射表，提升性能
      statusMap: {},
      statusTagMap: {
        0: 'info',      // 待售 - 灰色/蓝色
        1: 'success',   // 已售 - 绿色
        2: 'primary',   // 使用中 - 蓝色
        3: 'warning',   // 已消耗 - 橙色
        4: 'danger'     // 已封禁 - 红色
      },
      // rules表单验证
      rules: {
        deptName: [
          {required: true, message: '请选择状态', trigger: 'blur'}
        ]
      },
      formInline: {
        upload_key: '',
        status: -1,
        pageNo: 1,
        pageSize: 10
      },
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 创建完毕
   */
  created() {
    // 构建状态映射对象（排除 value=-1 的“请选择”）
    this.statusMap = this.status_type.reduce((map, item) => {
      if (item.value !== -1) {
        map[item.value] = item.key
      }
      return map
    }, {})
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取状态对应的文字
    statusText(status) {
      return this.statusMap[status] || '未知'
    },
    // 获取状态对应的标签类型
    statusTagType(status) {
      return this.statusTagMap[status] || 'info'
    },
    // 获取公司列表
    getdata(parameter) {
      this.loading = true
      getUploadKeyList(parameter)
        .then(res => {
          this.loading = false
          if (res.code !== 0) {
            if (res.code === 401) {
              setTimeout(() => {
                this.$store.commit('logout', 'false')
                this.$router.push({ path: '/login' })
                this.$message({
                  type: 'warning',
                  message: '登录失效，请重新登陆!'
                })
              }, 1000)
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          } else {
            this.listData = res.data.rows
            // 分页赋值
            this.pageparm.currentPage = res.data.pageNo
            this.pageparm.pageSize = res.data.pageSize
            this.pageparm.total = res.data.total
          }
        })
        .catch(err => {
          const {status} = err.response;
          if (status === 401 || status === 403) {
            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'warning',
              message: '登录失效，请重新登陆!'
            })
          } else {
            this.loading = false
            this.$message.error('数据加载失败，请稍后再试！')
          }
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.pageNo = parm.currentPage
      this.formInline.pageSize = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.formInline.pageNo = 1  // 重置页码
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改-' + row.upload_key + '-状态'
        this.editForm.id = row.id
        this.editForm.status = row.status
      }
    },
    handleGenKeys: function () {
      this.title = '补充秘钥'
      this.genKeyFormVisible = true
    },
    // 编辑保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          updateKeyStatus(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.code === 0) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    // 删除
    deleteItem(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteUploadKey({id: row.id})
            .then(res => {
              if (res.code === 0) {
                this.$message({
                  type: 'success',
                  message: '已删除!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    submitGen() {
      if (this.genKeyForm.count <= 0 || !/^\d+$/.test(this.genKeyForm.count)) {
        this.$message.error('请输入正确的正整数数量')
      } else {
        genNewUploadKeys({count: this.genKeyForm.count})
          .then(res => {
            if (res.code === 0) {
              this.genKeyFormVisible = false
              this.genKeyForm.count = 0
              this.loading = false
              this.getdata(this.formInline)
              this.$message({
                type: 'success',
                message: res.msg
              })
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          }).catch(err => {
          console.log('error', err)
          this.genKeyFormVisible = false
          this.loading = false
          this.$message.error('生成失败，请稍后再试！')
        })
      }
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
      this.genKeyFormVisible = false
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/views/keys/Keys.vue